import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { API } from '../utils/api';
import { toast } from 'sonner';

export function CompleteProfileModal() {
    const { user, setUser } = useAuth();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        phone: '',
        cedula: '',
        city: ''
    });

    useEffect(() => {
        if (user) {
            const isMissingData = !user.phone || !user.cedula || !user.city;
            if (isMissingData) {
                setFormData({
                    phone: user.phone || '',
                    cedula: user.cedula || '',
                    city: user.city || ''
                });
                setOpen(true);
            }
        }
    }, [user]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.phone || !formData.cedula || !formData.city) {
            toast.error('Por favor completa todos los campos.');
            return;
        }

        setLoading(true);
        try {
            await axios.put(`${API}/users/profile`, {
                name: user?.name || '', // Guard against undefined
                ...formData
            }, { withCredentials: true });
            
            toast.success('Perfil actualizado correctamente.');
            setOpen(false);
            
            // Actualizar el contexto de forma local
            if (setUser) {
              setUser({
                  ...user,
                  ...formData
              });
            }
            // Recargar la página para limpiar caché global si hiciera falta
            // window.location.reload();
        } catch (error) {
            console.error('Error updating profile:', error);
            toast.error(error.response?.data?.detail || 'Error al actualizar tu información.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent 
                className="sm:max-w-[425px]" 
                hideClose 
                onInteractOutside={(e) => e.preventDefault()} 
                onEscapeKeyDown={(e) => e.preventDefault()}
            >
                <DialogHeader>
                    <DialogTitle>Completa tu Registro</DialogTitle>
                    <DialogDescription>
                        Para poder continuar y asegurar el envío de cualquier premio, necesitamos que completes esta información importante.
                    </DialogDescription>
                </DialogHeader>
                <form onSubmit={handleSubmit} className="space-y-4 py-4">
                    <div className="space-y-2">
                        <Label htmlFor="phone">Celular</Label>
                        <Input
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Ej: 3001234567"
                            required
                        />
                    </div>
                    <div className="space-y-2">
                        <Label htmlFor="cedula">Cédula</Label>
                        <Input
                            id="cedula"
                            name="cedula"
                            value={formData.cedula}
                            onChange={handleChange}
                            placeholder="Cédula de ciudadanía"
                            required
                        />
                    </div>
                    <div className="space-y-2">
                        <Label htmlFor="city">Ciudad de Residencia</Label>
                        <Input
                            id="city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            placeholder="Ciudad donde resides"
                            required
                        />
                    </div>
                    <DialogFooter>
                        <Button type="submit" disabled={loading} className="w-full">
                            {loading ? 'Guardando...' : 'Guardar Información'}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
